export enum ChatAPIStatus {
  FEEDBACK_SUCCESS = 'FEEDBACK_SUCCESS',
  FEEDBACK_ERROR = 'FEEDBACK_ERROR',
}

export interface ChatAPITaskRequest {
  taskId: string;
  status: ChatAPIStatus;
}

export interface ChatAPITaskResponse {
  id: string;
  status: ChatAPIStatus;
}
